import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, Output, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import config from 'config/default.json';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs';
import { TableComponent } from 'src/app/back-office/components/table/table.component';
import { DialogComponent } from 'src/app/back-office/components/dialog/dialog.component';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';
import { ProjectSettingComponent } from 'src/app/back-office/components/project-content/project-setting/project-setting.component';
import { ProjectSplitingComponent } from 'src/app/back-office/components/edit-project/project-spliting/project-spliting.component';
import { ProjectEditingComponent } from 'src/app/back-office/components/edit-project/project-editing/project-editing.component';
import { FormControl } from '@angular/forms';
import Chart, { ChartConfiguration } from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.register(ChartDataLabels);

@Component({
  selector: 'app-project-content',
  templateUrl: './project-content.component.html',
  styleUrls: ['./project-content.component.scss', '../../components/table/table.component.scss']
})
export class ProjectContentComponent extends TableComponent{
  constructor(
    private elRef:ElementRef,
    public cdRef: ChangeDetectorRef,
    public helper: HelperModule,
    public dialog: MatDialog,
    private apiService: ApiServiceModule,
    private sharedService: SharedService,
    public sanitizer: DomSanitizer) {
      super(sanitizer);
  }
  userControl = new FormControl();
  userInputControl = new FormControl();
  startDateInputControl = new FormControl();
  endDateInputControl = new FormControl();
  allUsers:any = [];
  @Input() userInfos: { [x:string]: any } = new Map();
  @Input() data:{[x: string]: any}[]= [];
  @Input() platformInfos: { [x:string]: any } = new Map();

  userWaves:any = [] = [];
  onlyLastWave:boolean = true;
  totalContent:number = 0;
  totalEdited:number = 0;
  totalCLassified:number = 0;
  totalWords:number = 0;
  suppliers: any[] = [];
  creators: any[] = [];
  splitterWave: any[] = [];
  editorWave: any[] = [];
  podiumClassified: any[] = [];
  podiumEdited:any[] = [];
  chartClassified: Chart | null = null;
  chartEdited: Chart | null = null;

  ngOnInit(): void {
    this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/administration/load_waves', {}, this.userInfos['access_token']).subscribe((response:any)=>{
      this.userWaves = response;
    });
    this.loadStatistics();
    this.userInputControl.valueChanges.pipe(
      filter(query => query && query.length > 2),
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((query) => {
        this.sharedService.sendData({in_progress: true});
        return this.apiService.queryData(config.master.ndapi.url+'/enovsky/web/administration/search_user', {search_key: query}, this.userInfos['access_token'])
      })
    ).subscribe((options) => {
      this.allUsers = options;
      this.sharedService.sendData({in_progress: false});
    });
    this.buildData();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && !changes['data'].firstChange) this.buildData();
  }
  loadStatistics(){
    this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/project/load_stat', {id_user: this.userInfos['id_user'], privilege: this.userInfos['privilege'], platform_infos: this.platformInfos}, this.userInfos['access_token']).subscribe((response:any)=>{
      this.podiumClassified = response['podium_classified'];
      this.podiumEdited = response['podium_edited'];
      this.drawStatistics();
    })
  }
  resetDate(){
    this.startDateInputControl.setValue(null);
    this.endDateInputControl.setValue(null);
  }
  chargeData(){
    let startDate: any = new Date(this.startDateInputControl.value).toLocaleDateString("fr-FR").replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1')+ ' 00:00:00';
    let endDate:any = new Date(this.endDateInputControl.value).toLocaleDateString("fr-FR").replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1')+ ' 00:00:00';
    startDate = startDate.split('-')[0] == '1970' || startDate.includes('Invalid')? null: startDate;
    endDate = endDate.split('-')[0] == '1970' || endDate.includes('Invalid')? null: endDate;

    let dates = [startDate, endDate];
    dates = dates.filter(el => el != null);
    dates = dates.length > 1? dates: (dates.length == 1? [dates[0], dates[0]]: [null, null]);
   
    let data = {
      id_user: this.userInfos['id_user'], 
      id_user_filter: this.userControl.value,
      privilege: this.userInfos['privilege'],
      dates: dates,
      platform_infos: this.platformInfos
    }
    this.sharedService.sendData({in_progress: true});
    this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/project/load', data, this.userInfos['access_token']).subscribe((response)=>{
      this.data = response;
      this.buildData();
      this.helper.showToast("Data refreshed...");
      this.sharedService.sendData({in_progress: false});
    })
  
  }
  buildData(){
    this.dataSource = this.data.map((row) => {
      row['raw_percent'] = row['nb_raw'] > 0?  Math.round((row['nb_extracted'] / row['nb_raw']) * 100 * 100) / 100: 0;
      row['classified_percent'] = row['nb_content'] > 0?  Math.round((row['nb_classified'] / row['nb_content']) * 100 * 100) / 100: 0;
      row['edited_percent'] = row['nb_classified'] > 0?  Math.round((row['nb_edited'] / row['nb_classified']) * 100 * 100) / 100: 0;
      row['imported_percent'] = row['nb_edited'] > 0?  Math.round((row['nb_imported'] / row['nb_edited']) * 100 * 100) / 100: 0;
      return row;
    });
    this.suppliers = Array.from(new Set(this.dataSource.map(el=> el['user_supply_wave']?.trim()).filter(Boolean)));
    this.creators = Array.from(new Set(this.dataSource.map(el=>el['creator'])));
    this.splitterWave = Array.from(new Set(this.dataSource.map(el => el['user_split_wave']?.trim()).filter(Boolean)));
    this.editorWave = Array.from(new Set(this.dataSource.map(el=> el['user_edit_wave']?.trim()).filter(Boolean)));
    this.showedRows = this.dataSource;
    this.updateTotals();
    this.toggleOnlyCurrentWaves();
  }
  updateTotals(){
    this.totalContent = this.showedRows.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue['nb_content']), 0);
    this.totalEdited = this.showedRows.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue['nb_edited']), 0);
    this.totalCLassified = this.showedRows.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue['nb_classified']), 0);
    this.totalWords = this.showedRows.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue['nb_word']), 0);
  }
  toggleOnlyCurrentWaves(){
    this.onlyLastWave = !this.onlyLastWave;
    const userSplitWave = this.dataSource.reduce((max: any, item: any) =>
                              item.id_user_splitter == this.userInfos['id_user'] &&
                              item.year_month_split_wave > (max?.year_month_split_wave ?? 0) ? item : max, null
                          )?.user_split_wave;
    const userEditWave = this.dataSource.reduce((max: any, item: any) =>
                              item.id_user_editor == this.userInfos['id_user'] &&
                              item.year_month_edit_wave > (max?.year_month_edit_wave ?? 0) ? item : max, null
                          )?.user_edit_wave;
    let filterValues = this.onlyLastWave? [
      {column: 'user_split_wave',  value: userSplitWave},
      {column: 'user_edit_wave',  value: userEditWave}
    ]: [];
    this.applyFilterOr(filterValues);
    this.updateTotals()
  }
  projectOption(rowInfos:{ [x:string]: any }){
    const dialogRef = this.dialog.open(ProjectSettingComponent, {
      width: '70%',
      position: {top: '30px' },
      data: {row_infos: rowInfos, user_infos: this.userInfos, waves: this.userWaves, platform_infos: this.platformInfos}
    });
    dialogRef.afterClosed().subscribe((response:any) => {
      if(response && response.row){
        let result = response.row;
        this.dataSource = this.dataSource.map((element:any) => {
          if (element.id == result.id) {
            element.project_name = result.project_name;
            element.id_user_splitter = result.id_user_splitter;
            element.id_user_editor = result.id_user_editor;
            element.splitter = result.splitter;
            element.editor = result.editor;
            element.last_task = result.last_task;
            element.state = result.state;
            element.user_edit_splitter = result.user_edit_splitter
          }
          return element;
        });
        this.showedRows = this.showedRows.map((element:any) => {
          if (element.id == result.id) {
            element.project_name = result.project_name;
            element.id_user_splitter = result.id_user_splitter;
            element.id_user_editor = result.id_user_editor;
            element.splitter = result.splitter;
            element.editor = result.editor;
            element.last_task = result.last_task;
            element.state = result.state;
            element.user_edit_splitter = result.user_edit_splitter
          }
          return element;
        });
      }
      if(response && response.nb_word){
        /* const indexFound = this.showedRows.findIndex((element:any) => element.id === response.id);
        this.showedRows[indexFound]?.['nb_word'] = response.nb_word; */
        this.showedRows = this.showedRows.map((element:any) => {
          if (element.id == response.id) element.nb_word = response.nb_word;
          return element;
        });
        this.dataSource = this.dataSource.map((element:any) => {
          if (element.id == response.id) element.nb_word = response.nb_word;
          return element;
        });
      }
      if(response && response.action == 'delete_project'){
        this.dataSource = this.dataSource.filter((el:any)=> el.id != response.id_project_deleted);
        this.showedRows = this.showedRows.filter((el:any)=> el.id != response.id_project_deleted);
      }
    });
    
  }
  openSplitingEditing(rowInfos:{ [x:string]: any }){
    this.sharedService.sendData({in_progress: true});
    let data = {
      project: rowInfos, 
      platform_infos: this.platformInfos,
      filter_values: this.platformInfos['origin'] == 'virtualclass'? {id_country: rowInfos['id_country'], id_cycle: rowInfos['id_cycle'], id_region: rowInfos['id_region'], id_vcl_institution: rowInfos['id_vcl_institution']}: null,
    }
    if(['splitting', 'splitted'].includes(rowInfos['state'])){
      this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/project/split_detail', data, this.userInfos['access_token']).subscribe((response:any)=>{

        if(response.status){
          const dialogRef = this.dialog.open(ProjectSplitingComponent, {
            maxWidth: '100vw',
            maxHeight: '100vh',
            height: '100%',
            width: '100%',
            panelClass: 'full-screen-modal',
            data: {project: rowInfos, raw_data: response['raw_data'], content_data: response['content_data'], classify_data: response['classify_data'], user_infos: this.userInfos, platform_infos: this.platformInfos}
          });
          dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
          });
        }
        this.sharedService.sendData({in_progress: false});
      })
    }else
    
    if(rowInfos['state'] == 'editing'){
      this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/project/edit_detail', data, this.userInfos['access_token']).subscribe((response:any)=>{
        if(response.status){
          const dialogRef = this.dialog.open(ProjectEditingComponent, {
            maxWidth: '100vw',
            maxHeight: '100vh',
            height: '100%',
            width: '100%',
            panelClass: 'full-screen-modal',
            data: {project: rowInfos, content_data: response['content_data'], classify_data: response['classify_data'], user_infos: this.userInfos, platform_infos: this.platformInfos, source: rowInfos['type'] == 'backward'? 'content': 'project'}
          });
          dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
          });
        }
        this.sharedService.sendData({in_progress: false});
      })
    }else this.helper.showToast('Project not assigned for splitting...')
    
    
  }
  applyFilterLocal(element:any, column:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applyFilter(element.value, column);
    this.updateTotals()
    this.cdRef.detectChanges();
  }
  applySortLocal(element:any, column:string, type:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applySort(element, column, type);
    this.updateTotals()
    this.cdRef.detectChanges();
  }
  drawStatistics(){

    const labelsClassified = this.podiumClassified.map(u => u.user_name);
    const valuesClassified = this.podiumClassified.map(u => u.nb_element);

    const labelsEdited = this.podiumEdited.map(u => u.user_name);
    const valuesEdited = this.podiumEdited.map(u => u.nb_element);
    const extraValuesEdited = this.podiumEdited.map(u => u.nb_second_element);
    

    if(this.chartClassified) (this.chartClassified as Chart).destroy()
    if(this.chartEdited) (this.chartEdited as Chart).destroy()
      
    this.chartClassified = new Chart(this.elRef.nativeElement.querySelector('.spliting-podium'), this.barChartParams(labelsClassified, valuesClassified, [], 'Contents'));
    this.chartEdited = new Chart(this.elRef.nativeElement.querySelector('.editing-podium'), this.barChartParams(labelsEdited, valuesEdited, extraValuesEdited, 'Contents'));
    
  }
  barChartParams(labelsEdited: string[], valuesEdited: number[], extraValues: number[], keyWord:string): ChartConfiguration<'bar', number[], string> {
    const medals = ['🥇 ', '🥈 ', '🥉 '];
    const medalColors = ['#FFD700', '#C0C0C0', '#CD7F32'];
    const defaultColor = '#4e73df';
    const formattedLabels = labelsEdited.map((label, index) =>
      index < 3 ? medals[index] + label : label
    );

    const backgroundColors = valuesEdited.map((_, index) =>
      index < 3 ? medalColors[index] : defaultColor
    );
    return {
      type: 'bar',
      data: {
        labels: formattedLabels,
        datasets: [
          {
            data: valuesEdited,
            backgroundColor: backgroundColors,
            borderRadius: 5
          }
        ]
      },
      options: {
        responsive: true,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (ctx:any) => `${ctx.raw} ${keyWord}`
            }
          },
          datalabels: {
            anchor: 'end',
            align: 'top',
            font: {
              weight: 'bold'
            },
            formatter: (value: number, context: any) => {
              const index = context.dataIndex;
              return extraValues[index]; // show second value
            }
          }
        },
        scales: {
          x: {
            grid: { display: false }
          },
          y: {
            beginAtZero: true,
            grace: '10%',
            ticks: { precision: 0 },
              title: {
              display: true,
              text: keyWord,
              font: {
                size: 14,
                weight: 'bold'
              }
            }
          }
        }
      }
    };
  }

}
